export default __webpack_public_path__ + "static/media/PunkRockinDearborn.edd9bfbd.mp3";